"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHeader = void 0;
const tslib_1 = require("tslib");
const CardHeader_1 = tslib_1.__importDefault(require("@material-ui/core/CardHeader"));
const component_mapper_1 = require("@bluebase/component-mapper");
exports.CardHeader = component_mapper_1.componentMapper(CardHeader_1.default, {
    action: 'right',
    avatar: 'left',
    subheader: 'description',
}, { rest: true });
